import React from "react"

export const FormulareUndUnterlagenIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={33}
      viewBox="0 0 24 33"
      overflow="visible"
      {...props}
      style={{
        overflow: "visible",
        enableBackground: "new 0 0 24 33",
      }}
    >
      <style>
        {
          ".st3{stroke-linecap:square}.st3,.st4{fill:none;stroke:#035470;stroke-width:1.8}"
        }
      </style>
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter"
          filterUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={24}
          height={33}
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={33}
        id="path-1-inside-1_0_3985_1_"
      >
        <path
          d="M2.5 1.8h19.9c.4 0 .7.3.7.7v27.9c0 .4-.3.7-.7.7H2.5c-.4 0-.7-.3-.7-.7V2.5c0-.4.3-.7.7-.7z"
          style={{
            fill: "#fff",
            filter: "url(#Adobe_OpacityMaskFilter)",
          }}
        />
      </mask>
      <path
        d="M2.5 1.8h19.9c.4 0 .7.3.7.7v27.9c0 .4-.3.7-.7.7H2.5c-.4 0-.7-.3-.7-.7V2.5c0-.4.3-.7.7-.7z"
        style={{
          mask: "url(#path-1-inside-1_0_3985_1_)",
          fill: "none",
          stroke: "#035470",
          strokeWidth: 3.6,
        }}
      />
      <path
        style={{
          fill: "#ffd62e",
        }}
        d="M.1 5.7h19.1v28.1H.1z"
      />
      <path className="st3" d="m3.6 12 1.2 1 3.3-3M3.6 17.5l1.2 1 3.4-2.9" />
      <path className="st4" d="M3.4 22.9h12.8M3.4 26.6h12.8" />
    </svg>
  )
}
